<template>
	<div>
		<modal
			v-if="exibirModal"
			class="az-form-content"
			:exibir="exibirModal"
			:titulo="'Assinar Digitalmente'"
			:max-width="600"
			@close="fecharModalAssinatura"
		>
			<template #body>
				<div class="az-form-content cp-modal-form-content pa-4" style="height: 300px">
					<div class="mb-3">
						<label-personalizado nome-campo="Documentos Selecionados" class="pb-2"></label-personalizado>
						<v-card outlined class="document-list-card">
							<v-card-text class="pa-3">
								<div v-if="documento && (documento.titulo || documento.tituloDocumento)">
									<v-chip
										color="grey lighten-3"
										outlined
										small
										class="ma-1"
									>
										<v-icon left small>mdi-file-document</v-icon>
										{{ getTituloDocumento(documento) }}
									</v-chip>
									<v-divider class="my-2"></v-divider>
									<p class="text-caption grey--text text--darken-1 mb-0">
										Total: 1 documento selecionado
									</p>
								</div>
								<div v-else class="text-center pa-2">
									<v-icon size="48" color="grey lighten-1">mdi-file-document-outline</v-icon>
									<p class="text-body-2 grey--text text--darken-1 mt-2 mb-0">
										Nenhum documento selecionado
									</p>
								</div>
							</v-card-text>
						</v-card>
					</div>
					<div class="mb-0">
						<label-personalizado nome-campo="Certificado Digital" :obrigatorioPorPadrao="true"></label-personalizado>
						<combo-autocomplete
							key="digital"
							v-model="certificadoThumbprint"
							v-validate="{ required: true }"
							name="Certificado"
							dense
							clearable
							:items="certificados"
							item-text="prettyName"
							item-value="thumbprint"
							class="pt-0"
							placeholder="Selecione um certificado digital instalado"
							:error-messages="errors.collect('Certificado')"
              :disabled="certificados.length === 0"
						></combo-autocomplete>
						<p class="text-caption grey--text text--darken-1 mt-1 mb-0">
							<v-icon small color="grey darken-1" class="mr-1">mdi-information</v-icon>
							Certifique-se de que o certificado digital esteja instalado no seu computador
						</p>
					</div>
				</div>
			</template>

      <template #actions>
        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-space-between pb-3 pt-3">
          <botao-cancelar style="max-width: 60px" @cancelar="fecharModalAssinatura">Cancelar</botao-cancelar>
          <botao-salvar style="max-width: 60px"
                        :disabled="ehCampoCertificadoVazio"
                        label="Assinar"
                        @salvar="assinar"
          />
        </v-card-actions>
      </template>
		</modal>

		<modal-confirmacao
			:tituloModal="tituloModal"
			:exibirModal="exibirModalConfirmacao"
			:mensagemModal="mensagemConfirmacaoModal"
			:mensagemConfirmacao="mensagemConfirmacaoAcaoModal"
			@confirmar-acao="tratarEventoConfirmarAcaoModal"
			@cancelar-acao="tratarEventoCancelarAcaoModal"
		></modal-confirmacao>
	</div>
</template>

<script>

import Modal from "@/views/credenciamento/detalhe-credenciamento/commons/Modal.vue";
import ModalConfirmacao from "@/views/credenciamento/detalhe-credenciamento/commons/ModalConfirmacao.vue";

import { AzDigitalSignature } from '@azinformatica/loki'
import {actionTypes, mutationTypes} from "@/commons/constants";
import LabelPersonalizado from "@/views/credenciamento/detalhe-credenciamento/commons/LabelPersonalizado.vue";
import BotaoSalvar from "@/views/credenciamento/detalhe-credenciamento/commons/BotaoSalvar.vue";
import BotaoCancelar from "@/views/credenciamento/detalhe-credenciamento/commons/BotaoCancelar.vue";
import ComboAutocomplete from "@/views/credenciamento/detalhe-credenciamento/commons/ComboAutocomplete.vue";
import TextoVerMais from "@/views/credenciamento/detalhe-credenciamento/commons/TextoVerMais.vue";
import {mapState} from "vuex";

export default {
	name: 'formulario-assinatura-digital',
  components: {TextoVerMais, ComboAutocomplete, BotaoCancelar, BotaoSalvar, ModalConfirmacao, Modal, LabelPersonalizado},
  inject: ['$validator'],
	props: {
		documento: {
      type: Object,
      default: () => ({}),
		},
    exibirModal: {
      type: Boolean,
      required: true,
    },
    idLicitacao: {
      type: [String, Number],
      required: true,
    },
	},
	data: () => ({
		certificadoThumbprint: '',
		httpHeader: {},
		assinaturaDigital: null,
		certificados: [],
		exibirModalAssinaturaDigital: false,
		exibirModalConfirmacao: false,
		tituloModal: 'Extensão Lacuna WebPki',
		mensagemConfirmacaoModal: 'A extensão WebPki é necessária para continuar o processo da assinatura digital.',
		mensagemConfirmacaoAcaoModal: 'Deseja instalar agora?',
		confirmarAcaoModal: null,
		cancelarAcaoModal: null,
	}),
	computed: {
    ...mapState(['parametros']),
		ehCampoCertificadoVazio() {
			return !this.certificadoThumbprint
		},
		tituloCampo() {
			return this.documento.titulo || this.documento.tituloDocumento
		},
	},
	async mounted() {
    this.httpHeader = await this.criarTokenNoHeaderDasRequisicoes()

		this.$store.commit(mutationTypes.LOKI.SET_ACCESS_TOKEN, this.httpHeader)
		const configuracoes = await this.$store.dispatch(actionTypes.FLOWBEE.BUSCAR_CONFIGURACAO, this.httpHeader)
    this.$store.commit(mutationTypes.LOKI.SET_LACUNA_LICENSE, configuracoes.licencaLacuna)

    this.assinaturaDigital = new AzDigitalSignature({ store: this.$store })
    this.iniciarAssinatura()
  },
  watch: {
    documento: {
      handler() {
        this.$forceUpdate()
      },
      immediate: true,
      deep: true
    },
    exibirModal: {
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.$forceUpdate()
          })
        }
      },
      immediate: true
    }
  },
	methods: {
    async criarTokenNoHeaderDasRequisicoes() {
      const token = this.$store.state.parametros.propriedadesLicitacao.tokenRepositorio
      const header = { 'token-acesso': token }
      this.$store.commit(mutationTypes.PUB.SET_HTTP_HEADER, header)
      return header
    },
		async iniciarAssinatura() {
			this.setMensagemLoading('Iniciando serviço de assinatura...')

			this.habilitarLoadingGlobal()
			const webPkiInstalled = await this.assinaturaDigital.loadWebPki()
      this.desabilitarLoadingGlobal()

			if (webPkiInstalled) {
				this.certificados = await this.assinaturaDigital.listCertificates()
				this.exibirModalAssinaturaDigital = true
			} else {
				this.exibirModalExtensaoNaoInstalada()
			}
		},
		exibirModalExtensaoNaoInstalada() {
			this.exibirModalConfirmacao = true
			this.confirmarAcaoModal = this.confirmarModalExtensaoNaoInstalada
			this.cancelarAcaoModal = this.fecharModalExtensaoNaoInstalada
		},
		confirmarModalExtensaoNaoInstalada() {
			this.assinaturaDigital.redirectToInstallWebPki()
		},
		fecharModalExtensaoNaoInstalada() {
			this.exibirModalConfirmacao = false
			this.fecharModalAssinatura()
		},
		fecharModalAssinatura() {
			this.$emit('fechar-modal')
		},
		getTituloDocumento(documento) {
			if (!documento) {
				return 'Documento inválido'
			}

			return documento.titulo ? documento.titulo : documento.tituloDocumento;
		},
		async assinar() {
			this.setMensagemLoading('Assinando documento...')
      this.habilitarLoadingGlobal()

      const header = await this.criarTokenNoHeaderDasRequisicoes()

      if (this.assinaturaDigital && this.assinaturaDigital.store && this.assinaturaDigital.store.state.loki) {
          this.assinaturaDigital.store.state.loki.flowbee.accessToken = header
      }

      this.assinaturaDigital
          .sign(this.certificadoThumbprint, this.documento.idVirtualizado)
          .then(async () => {
            this.desabilitarLoadingGlobal()

            this.mostrarNotificacaoSucesso('Documento assinado com sucesso!')
            this.fecharModalAssinatura()
            this.$emit('assinatura-concluida')
          })
      .catch((erro) => {
        this.desabilitarLoadingGlobal()
        this.tratarErroAssinatura(erro)
      })
		},
		tratarErroAssinatura(erro) {
			const tipoErrosLacuna = {
				licencaInvalidaNoDominio: 'A licença fornecida não é válida para uso no domínio atual:',
			}

			if (erro.response && erro.response.data) {
				this.mostrarNotificacaoErro(erro.response.data.message)
			} else if (typeof erro === 'string' && erro.match(tipoErrosLacuna.licencaInvalidaNoDominio)) {
				const dominio = erro.replace(tipoErrosLacuna.licencaInvalidaNoDominio, '')
				this.mostrarNotificacaoErro('A licença atual não é válida para o domínio:' + dominio)
			} else {
				this.mostrarNotificacaoErro(erro)
			}
		},
		tratarEventoCancelarAcaoModal() {
			this.cancelarAcaoModal()
			this.mensagemConfirmacaoAcaoModal = 'Deseja realmente confirmar esta ação?'
		},
		tratarEventoConfirmarAcaoModal() {
			this.confirmarAcaoModal()
		},
	},
}
</script>
